
import Vue from 'vue'
import ActivityHero from './ActivityHero.vue'
import { mapGetters } from 'vuex'
import { ProjectPath } from '../channel.types'

export default Vue.extend({
  props: {
    path: Object,
  },

  data() {
    return {
      active_index: 0,
    }
  },
  mounted() {
    if (this.activities.length > 1) this.startInterval()
  },
  beforeDestroy() {
    this.stopInterval()
  },

  components: {
    ActivityHero,
  },
  methods: {
    extendPath(activity, activity_index): ProjectPath {
      return { ...this.path, activity, activity_index }
    },

    getNextIndex() {
      return this.active_index + 1 === this.activities.length
        ? 0
        : this.active_index + 1
    },
    startInterval() {
      this.interval = window.setInterval(
        () => (this.active_index = this.getNextIndex()),

        this.path.row.autoplay_speed
      )
    },
    stopInterval() {
      window.clearInterval(this.interval)
    },
    selectIndex(index) {
      this.active_index = index
    },
  },
  computed: {
    ...mapGetters({ activities: 'highlightedActivities' }),
  },
})
